import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { registerAccessExpiredNavigator } from "../../lib/accessExpired";

/**
 * Registers a React Router navigate callback so 403 access-expired responses
 * redirect client-side instead of forcing a full page reload.
 */
const AccessExpiredNavigationRegistrar = () => {
  const navigate = useNavigate();

  useEffect(() => {
    registerAccessExpiredNavigator(() => {
      navigate("/access-expired", { replace: true });
    });
  }, [navigate]);

  return null;
};

export default AccessExpiredNavigationRegistrar;
